import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLFormElement> {
  static targets = ["kind", "payload"];

  declare readonly kindTarget: HTMLSelectElement;
  declare readonly payloadTarget: HTMLTextAreaElement;

  connect() {
    if (this.payloadTarget.value.trim() !== "") {
      return;
    }

    this.sync();
  }

  sync() {
    const selectedOption = this.kindTarget.selectedOptions.item(0);

    if (!selectedOption) {
      return;
    }

    this.payloadTarget.value = selectedOption.dataset.exampleJson || "";
  }
}
